'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

require('./Tip.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tip = function (_Component) {
  _inherits(Tip, _Component);

  function Tip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tip.__proto__ || Object.getPrototypeOf(Tip)).call.apply(_ref, [this].concat(args))), _this), _this.getArrowStyles = function () {
      var _this$props = _this.props,
          position = _this$props.position,
          direction = _this$props.direction;


      switch (direction) {
        case 'top':
        case 'bottom':
          return { left: position };
        case 'left':
        case 'right':
          return { top: position };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tip, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          arrowRef = _props.arrowRef,
          color = _props.color,
          direction = _props.direction,
          position = _props.position,
          children = _props.children,
          shadow = _props.shadow,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['arrowRef', 'color', 'direction', 'position', 'children', 'shadow', 'size']);

      var classes = (0, _classnames4.default)('ax-tip--' + direction, (_classnames = {}, _defineProperty(_classnames, 'ax-tip--' + color, color), _defineProperty(_classnames, 'ax-tip--shadow', shadow), _classnames));

      var arrowClasses = (0, _classnames4.default)('ax-tip__arrow', _defineProperty({}, 'ax-tip__arrow--' + size, size));

      return _react2.default.createElement(
        _Base2.default,
        _extends({ className: classes }, rest),
        _react2.default.createElement('span', { className: arrowClasses, ref: arrowRef, style: position ? this.getArrowStyles() : {} }),
        _react2.default.createElement(
          _Base2.default,
          { className: 'ax-tip__content' },
          children
        )
      );
    }
  }]);

  return Tip;
}(_react.Component);

Tip.propTypes = {
  /** optional property which should be provided in case positioning of the tip is done using popperJs. If this value is true, the value of position prop will be ignored. */
  arrowRef: _propTypes2.default.func,
  /** The content on which the tip should be placed. */
  children: _propTypes2.default.node,
  /** Background color for the tip */
  color: _propTypes2.default.oneOf(['success', 'warning', 'error', 'info', 'shade-1', 'shade-2', 'shade-3', 'shade-4', 'carbon', 'white']),
  /** The direction at which the Tip should be pointing. The directions are opposite, for example,
   * if the arrow should be placed on the 'left', its direction prop should be 'right'. The same applies for 'top' and 'bottom'. */
  direction: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
  /** The position of the Tip along the baseline, can be any valid css units including px/rem/percentage. Should be adjusted according ot the use case */
  position: _propTypes2.default.string,
  /** The Tip can be configured to have a shadow effect. This value is true by default */
  shadow: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium'])
};
Tip.defaultProps = {
  shadow: true,
  direction: 'top',
  size: 'medium'
};
exports.default = Tip;